// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICopyFilesRequestDto
 */
export interface ICopyFilesRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ICopyFilesRequestDto
     */
    source_document_ids: Array<number>;
}

/**
 * Check if a given object implements the ICopyFilesRequestDto interface.
 */
export function instanceOfICopyFilesRequestDto(value: object): value is ICopyFilesRequestDto {
    if (!('source_document_ids' in value) || value['source_document_ids'] === undefined) return false;
    return true;
}

export function ICopyFilesRequestDtoFromJSON(json: any): ICopyFilesRequestDto {
    return ICopyFilesRequestDtoFromJSONTyped(json, false);
}

export function ICopyFilesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICopyFilesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'source_document_ids': json['source_document_ids'],
    };
}

export function ICopyFilesRequestDtoToJSON(json: any): ICopyFilesRequestDto {
    return ICopyFilesRequestDtoToJSONTyped(json, false);
}

export function ICopyFilesRequestDtoToJSONTyped(value?: ICopyFilesRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_document_ids': value['source_document_ids'],
    };
}

